"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _MediaContext = require("../../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Default = function Default(props) {
  return props.children ? props.children({
    currency: props.context.currency,
    toggle: props.toggle
  }) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.SM
  }, !props.shrinkMobile && /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    text: props.getLabel(props.context.currency),
    onClick: props.toggle
  }))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.SM
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    text: props.getLabel(props.context.currency, true),
    buttonType: props.buttonType,
    onClick: props.toggle
  }))));
};
Default.propTypes = {
  buttonType: _propTypes["default"].string,
  shrinkMobile: _propTypes["default"].bool,
  getLabel: _propTypes["default"].func,
  toggle: _propTypes["default"].func,
  context: _propTypes["default"].object,
  children: _propTypes["default"].any
};
Default.defaultProps = {
  buttonType: _constants.BUTTON_TYPES.WHITE,
  shrinkMobile: false
};
var _default = exports["default"] = Default;